import { Component, OnInit } from '@angular/core';
/**
 * Review
 * Todo:
 * Зачем отдельный компонент? Можно сделать в app.component.html один раз вёрстку, что бы не использовать
 * каждый раз компонент хедера и футера
 */
@Component({
  selector: 'header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/backend/NasheDelo/WebLombard/client/src/app/header/header.component.ts